import { FormControl, FormGroupDirective } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';

/**
 * Custom ErrorStateMatcher which returns true (error exists) when
 * the control is invalid and the control has been touched
 */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | null
  ): boolean {
    // return control.parent.invalid && control.touched;
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

/**
 * Collection of reusable RegExps
 */
export const regExps: { [key: string]: RegExp } = {
  email: /^[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}/,
  password: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,20}$/,
  phone: /^([0-9]*)$/
};

/**
 * Collection of reusable error messages
 */
export const errorMessages: { [key: string]: string | Object } = {
  userlevelname: {
    required: 'Name is required',
    minlength: 'Name must be at least 6 characters long',
    maxlength: 'Name must not exceed 20 characters long',
    invalid: 'Name already in use'
  },
  fullname: {
    required: 'Fullname is required',
    minlength: 'Fullname must be at least 6 characters long',
    maxlength: 'Fullname must not exceed 20 characters long'
  },
  phone: {
    required: 'Phone is required',
    invalid: 'Invalid phone number',
    minlength: 'Phone Number must be at least 6 digit long'
  },
  email: {
    required: 'E-mail is required',
    invalid: 'Please enter a valid email address',
    minlength: 'E-mail must be at least 6 characters long',
    exists: 'E-mail has already been registered'
  },
  username: {
    required: 'Username is required',
    minlength: 'Username must be at least 6 characters long',
    maxlength: 'Username must not exceed 20 characters long',
    exists: 'Username has already been taken'
  },
  company: 'Please complete your data',
  oldPassword: {
    required: 'Old Password is required',
    minlength: 'Please re-enter your old password'
  },
  password: {
    required: 'Password is required',
    minlength: 'Password must be at least 6 characters long',
    maxlength: 'Password must not exceed 20 characters long',
    pattern: 'Password must contain at least one number and special character'
  },
  confirmPassword: 'Passwords must match'
};



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/validators/custom-validator.ts